<template>
    <b-button
        @click="() => { modalState = true }"
        size="sm"
        :disabled="disabled"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
        block
    ><!-- button -->
        <span v-if="httpRequestInProgress">
            <b-spinner
                type="grow"
                label="Loading..."
                small
            />
            </span>
        <span v-else>Erstatten o. M. <span v-if="authorization.dev">[REFUND_OK: 4]</span></span>
        <b-modal
            v-model="modalState"
            id="modal-refund-silent"
            title="Bestellung Erstatten o. M."
            size="md"
            @hidden="() => { this.modalState = false; this.userConsent = false }"
        ><!-- modal -->
            <p>Diese Bestellung wirklich <b>ohne Meldung</b> Erstatten ?</p>
            <b-checkbox v-model="userConsent"> Ich habe die Bestellung erfolgreich manuell auf dem Marktplatz erstattet.</b-checkbox>
            <div slot="modal-footer" class="w-100">
               <b-button class="float-right mx-1"
                  centered
                  size="md"
                  variant="danger"
                  :disabled="!userConsent"
                  @click="submit()"
               >erstatten</b-button>
               <b-button
                  class="float-right"
                  size="md"
                  variant="secondary"
                  @click="() => { this.modalState = false; this.userConsent = false }"
                >abbrechen</b-button>
            </div>
        </b-modal>


    </b-button>
</template>
<script>
    export default {
        props: ['customerOrder', 'orderStates', 'authorization']
        ,data() {
            return {
                modalState: false
              , httpRequestInProgress: false
              , userConsent: false
            }
        }
        ,computed: {
            disabled: function() {
               for(let history of this.customerOrder.customerorderhistories) {
                  if(history.lastUpdateReason.includes("Delivery Job")) {
                    //...otherwise disable button if customerOrder is not in state WAIT or OPEN.               
                    return ![this.orderStates.codes.WAIT, this.orderStates.codes.OPEN].includes(this.customerOrder.orderState);
                  }
               }
               //if no history entry with the substring "Delivery Job" is found, disable the button. Sorta means that I can manually add a comment Delivery Job, and it will allow it, technically.
               return false;
            }
        }
        ,methods: {
            submit() {
                let payload = {
                    orderState: this.orderStates.codes.REFUND_OK,
                    customerOrderId: this.customerOrder.id
                }
                this.httpRequestInProgress = true;
                this.modalState = false;
                this.userConsent = false;
                // guarantees a minium delay of 750ms or longer, if request takes longer. The animation looks very consistent thereby.
                //NICE very cool trick, gotta remember this one
                Promise.all([
                    axios.post('/customerorder/action/refundsilent', payload),
                    new Promise(r => setTimeout(r, 750))
                ]).then( () => {
                    // let clone = _.deepClone(this.customerOrder);
                    // clone.orderState = this.orderStates.codes.WAIT;
                    this.$emit('mutatedOrderState', this.orderStates.codes.REFUND_OK);
                    this.httpRequestInProgress = false;
                }).catch( error => {
                    alert("Konnte Bestellung nicht erstatten.");
                    console.error(error);
                });

            }


        }
    }
</script>
